import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const connectionString =
  typeof process.env.QR_APP_INSIGHTS_CONNECTION_STRING === 'string'
    ? process.env.QR_APP_INSIGHTS_CONNECTION_STRING.trim()
    : '';

if (connectionString) {
  const appInsights = new ApplicationInsights({
    config: {
      connectionString,
    },
  });
  appInsights.loadAppInsights(false);
  appInsights.trackPageView();
}
